import React, { useState } from "react";
import axios from "axios";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "./ui/card";
import { Label } from "./ui/label";

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const params = new URLSearchParams();
      params.append('username', username);
      params.append('password', password);
      
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
      const response = await axios.post(`${BACKEND_URL}/api/login`, params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      
      const { access_token } = response.data;
      localStorage.setItem("token", access_token);
      onLogin(access_token);
    } catch (err) {
      setError("Hibás felhasználónév vagy jelszó");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#050505]">
      <Card className="w-[400px] bg-[#111] border-[#333] text-white shadow-2xl">
        <CardHeader className="text-center">
          <CardTitle className="text-3xl font-serif tracking-widest text-gold-500 uppercase">
                 Budapesti Jogászbál
          </CardTitle>
          <CardDescription className="text-gray-400">
            Kérjük, jelentkezzen be az adminisztrációs felülethez
          </CardDescription>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="username">Felhasználónév</Label>
              <Input
                id="username"
                type="text"
                placeholder="E-mail cím"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="bg-[#1a1a1a] border-[#333] focus:border-gold-500"
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Jelszó</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-[#1a1a1a] border-[#333] focus:border-gold-500"
                required
              />
            </div>
            {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
          </CardContent>
          <CardFooter>
            <Button type="submit" className="w-full bg-white text-black hover:bg-gray-200 font-bold py-6">
              BEJELENTKEZÉS
            </Button>
          </CardFooter>
        </form>
      </Card>
      
      <style>{`
        .text-gold-500 {
          color: #d4af37;
        }
        .border-gold-500:focus {
          border-color: #d4af37;
        }
      `}</style>
    </div>
  );
};

export default Login;
